/**
 * This mixin handles social actions (like, save, follow, share).
 * Works with Social/Button.pug template.
 */
export default {

    props: {
        item: {             type: Object },
        resource: {         type: String }, // resource type: actors, artworks etc
        className: {        type: String },
        withTooltip: {      type: Boolean, default: false },
        disabled: {         type: Boolean }
    },

    components: {
        // DxTooltip: () => import('devextreme-vue/tooltip')
    },

    data: function () {
        return {
            operation: '', // override (save, like, follow, share)
            undoable: true,
            active: false,
            isAllowed: false,
            busy: false,
            showModalLogin: false,
            showTooltip: false,
            tooltipMessage: null,
            isAuthenticated: false,
            error: null
        };
    },

    watch: {
        item: function () {
            this.update();
        }
    },

    beforeMount: function () {
        this.isAuthenticated = !!this.$store.getters['user/isAuthenticated'];
        this.$eventBus.$on('auth-change', this.onAuthChange);
    },

    mounted: function () {
        this.update();
    },

    beforeDestroy: function () {
        this.$eventBus.$off('auth-change', this.onAuthChange);
    },

    methods: {
        onAuthChange: function (auth) {
            this.isAuthenticated = auth?.authenticated === true;
            this.isAllowed = !!this.isAuthenticated;
        },

        update: function () {
            this.active = this.isActive(this.item);
            this.isAllowed = !!this.isAuthenticated;
        },

        isActive: function (item) {
            if (!item) {
                return false;
            }
            let items = [];
            switch (this.operation) {
            case 'save':
                items = this.$store.getters['user/getSaved'];
                break;
            case 'heart':
                items = this.$store.getters['user/getLiked'];
                break;
            case 'follow':
                items = this.$store.getters['user/getFollowed'];
                break;
            case 'share':
                items = this.$store.getters['user/getShared'];
                break;
            default:
                return false;
            }

            // Followed items contains a wrapper for Actor, Collection, Organization etc
            const key = this.$helpers.getResourceKey(this.resource);
            const value = _.chain(items).map(key).compact().find({Id: item.Id}).value();
            return !!value;
        },

        /**
         * Adds `item` to stored profile items.
         * Stored profile items are keyed as {Actor: item}, {Event: item} etc
         */
        addProfileItem: function (item) {
            const storeItem = {};
            storeItem[this.$helpers.getResourceKey(this.resource)] = item;
            switch (this.operation) {
            case 'save':
                this.$store.commit('user/addSavedItem', storeItem);
                break;
            case 'heart':
                this.$store.commit('user/addLikedItem', storeItem);
                break;
            case 'follow':
                this.$store.commit('user/addFollowedItem', storeItem);
                break;
            case 'share':
                this.$store.commit('user/addSharedItem', storeItem);
                break;
            default:
                return false;
            }
        },

        /**
         * Removes `item` from stored profile items.
         * Stored profile items are keyed as {Actor: item}, {Event: item} etc
         */
        removeProfileItem: function (item) {
            const storeItem = {};
            storeItem[this.$helpers.getResourceKey(this.resource)] = item;
            switch (this.operation) {
            case 'save':
                this.$store.commit('user/removeSavedItem', storeItem);
                break;
            case 'heart':
                this.$store.commit('user/removeLikedItem', storeItem);
                break;
            case 'follow':
                this.$store.commit('user/removeFollowedItem', storeItem);
                break;
            case 'share':
                this.$store.commit('user/removeSharedItem', storeItem);
                break;
            default:
                return false;
            }
        },

        /**
         * Tooltip, default text item TagLine.
         */
        getTooltipText: function () {
            return this.item && this.item.TagLine;
        },

        onMouseEnter: function () {
            this.tooltipMessage = this.getTooltipText();
            this.showTooltip = true;
            this.error = null; // will enable onMouseLeave to hide tooltip
        },

        onMouseLeave: function () {
            if (!this.error) {
                this.showTooltip = false;
            }
        },

        onClick: function () {
            // preconditions
            if (this.busy || this.disabled || !this.resource || !this.item || !this.isAllowed) {
                return false;
            }

            // display busy spinner
            this.busy = true;
            this.error = null;
            // do operation if feature is not active (not liked, not followed) or is fire-and-forget (share)
            if (!this.active || !this.undoable) {
                this.$SVC.putOperation(this.resource, this.item.Id, this.operation)
                    .then((response) => {
                        // console.log(response);
                        this.addProfileItem(this.item);
                        this.active = true;
                        this.$emit('change', 1);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.busy = false;
                    });
            }
            // else undo
            else if (this.undoable) {
                this.$SVC.putOperation(this.resource, this.item.Id, `un${this.operation}`)
                    .then((response) => {
                        // console.log(response);
                        this.removeProfileItem(this.item);
                        this.active = false;
                        this.$emit('change', -1);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.busy = false;
                    });
            }
        },

        /**
         * Handle request error.
         * Show generic "network error" message in the tooltip.
         */
        handleError: function (error) {
            this.tooltipMessage = this.$t('common.networkError');
            this.showTooltip = true;
            this.error = error;
        },

        // toggleModalLogin: function (error) {
        //     this.$eventBus.$emit('login-required', error);
        // },

        getClassName: function () {
            return [
                this.className,
                `do-${this.operation}`,
                this.active ? 'active' : '',
                this.disabled ? 'disabled' : '',
                this.busy ? 'busy' : '',
                !this.isAllowed ? 'help-cursor' : '' // affects css cursor property!
            ].join(' ');
        }
    }
};
